import Domain from "./domain";
export default {
  methods: {
    createNewModule: async function(mod) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "module",
          mod,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getModules: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "module/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteModule: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "module/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    assignModulesToCompany: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "module/assing/company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    assignCompaniesToModule: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "company/modules",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
